var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper countdown"},[_vm._l((_vm.from),function(n){return [_c('span',{ref:"number",refInFor:true,staticClass:"number",style:({ 'font-size': _vm.fontSize })},[_vm._v(_vm._s(_vm.from - ( n - 1 )))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }